import React from 'react';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex layout-container">
      <div className="no-print">
        <Sidebar />
      </div>
      {/* min-w-0: a flex child defaults to min-width:auto and refuses to shrink below its
          content, so one wide row pushed the whole column past the viewport — 824px at a
          375px screen, and unreachable because html/body are overflow-x:visible. */}
      <div className="flex-1 min-w-0 flex flex-col md:ml-16 layout-main-content">
        <main className={`flex-1 px-4 py-4 md:px-6 md:py-6 mt-16 md:mt-0 ${className}`}>
          <div className="container mx-auto max-w-8xl">{children}</div>
        </main>
        <footer className="bg-white border-t border-gray-200 py-6 px-4 no-print">
          <div className="container mx-auto text-center text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Bluepill Inc.
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Layout;
